import { createContext, useState } from "react";

export const TerritoryContext = createContext({
    territories: {
        provinces: [], 
        municipalities: [], 
        districts: []
    },
    setTerritories: (territories) => {},
    loadingSet: {},
    setLoadingSet: (loadingSet) => {},
})

export const TerritoryProvider = ({children}) => {

    const [territories, setTerritories] = useState({ provinces: [], municipalities: [], districts: [] })

    const [loadingSet, setLoadingSet] = useState(
        { provinces: false, municipalities: false, districts: false }
    )

    return (
        <TerritoryContext.Provider value={{
            territories,
            setTerritories,
            loadingSet,
            setLoadingSet,
        }}>
            {children}
        </TerritoryContext.Provider>
    )
}